import Icon from "@mui/icons-material/AccountBalance";
import SadaratsList from "./SadaratsList";
import SadaratsCreate from "./SadaratsCreate";
import SadaratsEdit from "./SadaratsEdit";

export default {
  list: SadaratsList,
  create: SadaratsCreate,
  edit: SadaratsEdit,
  icon: Icon,
  label: "Sadarats",
  options: { label: "Sadarats" },
  name: "sadarats",
};
